"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import CityCheckBoxSvg from "../../city-checbox-svg";
import { getFilterValue } from "@packages/lib/utlils/filters/result-filters";
import { generatePathName } from "@packages/lib/utlils/filters/result-filters";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
import { useSearchParams } from "next/navigation";
const CityCheckBoxComponent = ({
  index,
  cityItem,
  keyName,
  formUrl,
  appendSearchParams,
}: any) => {
  const searchParams = useSearchParams();
  const [isCityChecked, setIsCityChecked] = useState(false);
  const {
    slug,
    prepopulateFilter,
    selectedLocation,
    setPrepopulateFilter,
    setSelectedLocation,
  } = useFilterContext();

  useEffect(() => {
    const arrayOfLocations = prepopulateFilter?.location?.split("+") || [];
    setIsCityChecked(arrayOfLocations?.includes(cityItem?.cityTextKey));
  }, [prepopulateFilter?.location]);

  const cityCheckBoxClicked = (cityTextKey: string) => {
    let appliedCities: any = getFilterValue(keyName?.location, searchParams);
    if (!Array.isArray(appliedCities)) {
      appliedCities = appliedCities ? [appliedCities] : [];
    }
    if (appliedCities.includes(cityTextKey)) {
      appliedCities = appliedCities?.filter(
        (cityItem: any) => cityItem !== cityTextKey
      );
    } else {
      appliedCities?.push(cityTextKey);
    }
    if (appliedCities?.length > 0) {
      setSelectedLocation("city");
    }
    appendSearchParams("location", appliedCities?.join("+"));
  };
  return (
    <>
      <div className="form_check relative" key={index}>
        <div className="flex items-start gap-[8px]">
          <div className="checkbox_card">
            <Link
              className="hidden"
              id={keyName?.location + cityItem?.cityTextKey}
              href={{
                pathname: generatePathName(slug, keyName?.location),
                query: formUrl(keyName?.location, cityItem?.cityTextKey),
              }}
            >
              {cityItem?.cityName}
            </Link>
            <input
              disabled={selectedLocation === "region"}
              type="checkbox"
              checked={isCityChecked}
              onChange={() => {
                if (selectedLocation === "region") return;
                setIsCityChecked(!isCityChecked);
                setPrepopulateFilter((prev: any) => ({
                  ...prev,
                  city:
                    prev?.city == cityItem?.cityTextKey
                      ? ""
                      : cityItem?.cityTextKey,
                }));
                cityCheckBoxClicked(cityItem?.cityTextKey);
              }}
              className="form-checkbox hidden"
              id={cityItem?.cityName}
              name={cityItem?.cityName}
            />
            <label
              htmlFor={cityItem?.cityName}
              className="flex justify-center items-center w-[16px] h-[16px] rounded-[3px] border-2 border-grey-600 my-[2px] group-checked:bg-primary-400 cursor-pointer"
            >
              <CityCheckBoxSvg />
            </label>
          </div>
          <label
            htmlFor={cityItem?.cityName}
            className="check-label small font-normal text-grey300 w-[calc(100%_-_28px)]"
          >
            {cityItem?.cityName}
          </label>
        </div>
      </div>
    </>
  );
};

export default CityCheckBoxComponent;
